export const columns = {
  productType: 'Typ',
  productSubtype: 'Podtyp',
  brand: 'Marka',
  brandModel: 'Model',
  version: 'Wersja',
  status: 'Status',
  createdBy: 'Autor',
  actions: 'Akcje',
  label: 'Etykieta',
  description: 'Opis',
  code: 'Kod',
  createdAt: 'Utworzono',
  updatedAt: 'Zaktualizowano',
  name: 'Nazwa',
  nameAndSurname: 'Imię i nazwisko',
  email: 'Email',
  roles: 'Role',
  active: 'Aktywny',
  stepLabel: 'Krok',
  productIndex: 'Indeks produktu',
}
